<template>
    <form id="register-form" @submit.prevent="register">
        <div class="u-margin-bottom-narrow">
            <div class="layout | authentication__form-email">
                <div class="layout__item u-1/2-desk">
                    <text-input
                        v-model="form.email"
                        :error="form.errors.first('email')"
                        :label="trans('authentication.register.email')"
                        name="email"
                        class="field__label--register field__input--register | u-full-width"
                        required
                        focus
                    />
                </div>
                <!--
                             -->
                <div class="layout__item u-1/2-desk">
                    <div class="u-flex-center">
                        <svg width="20" height="20" viewBox="0 0 20 20" class="icon | u-margin-right-inline">
                            <use xlink:href="../assets/feather-icons/icons.svg#info"></use>
                        </svg>
                        <small class="authentication__email-info">
                            {{ trans('authentication.register.email-info') }}
                        </small>
                    </div>
                </div>
            </div>

            <div class="layout">
                <div class="layout__item u-1/2-desk">
                    <text-input
                        v-model="form.first_name"
                        :error="form.errors.first('first_name')"
                        :label="trans('authentication.register.first-name')"
                        name="first_name"
                        class="field__label--register field__input--register | u-full-width"
                        required
                    />
                </div>
                <!--
                             -->
                <div class="layout__item u-1/2-desk">
                    <text-input
                        v-model="form.last_name"
                        :error="form.errors.first('last_name')"
                        :label="trans('authentication.register.last-name')"
                        name="last_name"
                        class="field__label--register field__input--register | u-full-width"
                        required
                    />
                </div>
            </div>

            <div class="layout">
                <div class="layout__item u-1/2-desk">
                    <text-input
                        v-model="form.phone"
                        :error="form.errors.first('phone')"
                        :label="trans('authentication.register.phone')"
                        name="phone"
                        class="field__label--register field__input--register | u-full-width"
                        required
                    />
                </div>
                <!--
                             -->
                <div class="layout__item u-1/2-desk">
                    <text-input
                        v-model="form.organization"
                        :error="form.errors.first('organization')"
                        :label="trans('authentication.register.organization')"
                        name="organization"
                        class="field__label--register field__input--register | u-full-width"
                    />
                </div>
            </div>

            <div class="layout">
                <div class="layout__item u-1/2-desk">
                    <text-input
                        v-model="form.street_name"
                        :error="form.errors.first('street_name')"
                        :label="trans('authentication.register.street-name')"
                        name="street_name"
                        class="field__label--register field__input--register | u-full-width"
                        required
                    />
                </div>
                <!--
                             -->
                <div class="layout__item u-1/2-desk">
                    <text-input
                        v-model="form.street_number"
                        :error="form.errors.first('street_number')"
                        :label="trans('authentication.register.street-number')"
                        name="street_number"
                        class="field__label--register field__input--register | u-full-width"
                        required
                    />
                </div>
            </div>

            <div class="layout">
                <div class="layout__item u-1/2-desk">
                    <div class="layout">
                        <div class="layout__item u-1/3-desk">
                            <text-input
                                v-model="form.zip_code"
                                :error="form.errors.first('zip_code')"
                                :label="trans('authentication.register.zip_code')"
                                name="zip_code"
                                class="field__label--register field__input--register | u-full-width"
                                required
                            />
                        </div>
                        <!--
                                      -->
                        <div class="layout__item u-2/3-desk">
                            <text-input
                                v-model="form.city"
                                :error="form.errors.first('city')"
                                :label="trans('authentication.register.city')"
                                name="city"
                                class="field__label--register field__input--register | u-full-width"
                                required
                            />
                        </div>
                    </div>
                </div>
                <!--
                             -->
                <div class="layout__item u-1/2-desk">
                    <single-select
                        v-model="form.country_code"
                        :error="form.errors.first('country_code')"
                        :label="trans('authentication.register.country')"
                        :options="countryValues"
                        optionLabel="countryName"
                        optionValue="countryCode"
                        name="country_code"
                        class="field__label--register field__input--register | u-full-width"
                        required
                    />
                </div>
            </div>
        </div>

        <div class="field field--check | u-text-white u-margin-bottom-narrow-narrow" :class="{ hasError: form.errors }">
            <label class="field__label">
                <input v-model="form.terms" class="field__input" name="terms" type="checkbox" />
                <small>
                    <span
                        class="authentication__form-term-link"
                        v-html="trans('authentication.register.terms', { url: this.privacyLink })"
                    />
                </small>
            </label>
            <br />
            <template v-if="form.errors.first('terms')">
                <span class="field__message">
                    <small>{{ form.errors.first('terms') }}</small>
                </span>
            </template>
        </div>

        <div class="layout | u-flex-center">
            <div class="layout__item u-1/2-desk | u-margin-bottom-narrow-narrow">
                <span class="authentication__required-fields">
                    <small>{{ trans('authentication.register.required-fields') }}</small>
                </span>
            </div>
            <!--
            -->
            <div class="layout__item u-1/2-desk">
                <slot name="registration-button"></slot>
            </div>
        </div>
    </form>
</template>
<script>
import { Way2Form } from 'relapp-way2forms';
import { Api, apiMixin } from 'relapp-api';

export default {
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            form: new Way2Form({
                email: null,
                first_name: null,
                last_name: null,
                phone: null,
                organization: null,
                street_name: null,
                street_number: null,
                zip_code: null,
                city: null,
                country_code: 'NL',
                terms: false
            }),
            countries: []
        };
    },
    mixins: [apiMixin],
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        Api.get('/countries/nl.json').then(response => {
            this.countries = response.data;
        });
    },
    computed: {
        /**
         * Return the countries with a label and value.
         *
         * @return {array}
         */
        countryValues() {
            return Object.entries(this.countries).map(country => ({
                countryCode: country[0],
                countryName: country[1]
            }));
        },

        /**
         * Return the privacy link.
         *
         * @return {array}
         */
        privacyLink() {
            return process.env.VUE_APP_PRIVACY_LINK;
        }
    },
    methods: {
        /**
         * Submit registration form
         */
        register() {
            this.$emit('submit', this.form);
        }
    }
};
</script>
